import axios from "axios";

const authApi = process.env.REACT_APP_API_AUTH;
export const generateOtp = async (email) => {
  try {
    const response = await axios.post(`${authApi}/generate-otp?email=${email}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const verifyOtp = async (email, otp) => {
  try {
    const response = await axios.post(
      `${authApi}/verify-otp?email=${email}&otp=${otp}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const generateQRCodeAuth = async (username) => {
  try {
    const response = await axios.get(`${authApi}/2fa/setup?username=${username}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyQRCodeAuth = async (data) => {
  try {
    const response = await axios.post(`${authApi}/2fa/verify`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const activeQRCodeAuth = async (data) => {
  try {
    const response = await axios.post(`${authApi}/2fa/enable?username=${data?.username}&code=${data?.code}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DiasableQRCode = async (data) => {
  try {
    const response = await axios.post(`${authApi}/2fa/reset/request?username=${data?.username}&frontendUrl=${data?.frontendUrl}`);
    return response;
  } catch (error) {
    throw error;
  }
};
